import { render, staticRenderFns } from "./salesBilling.vue?vue&type=template&id=4dbb394c&scoped=true&"
import script from "./salesBilling.vue?vue&type=script&lang=js&"
export * from "./salesBilling.vue?vue&type=script&lang=js&"
import style0 from "./salesBilling.vue?vue&type=style&index=0&id=4dbb394c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dbb394c",
  null
  
)

export default component.exports